import React, { FC } from 'react'

import { IconNeedHelpProps } from './IconNeedHelp.types'
import * as Styled from './styles/IconNeedHelp.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNeedHelp: FC<IconNeedHelpProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNeedHelpProps['size'],
  isResponsive = false,
}: IconNeedHelpProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M11.16 9.078h31.746v20.344' stroke='#fff' strokeLinecap='round' strokeWidth='2' />
        <path
          d='M42.906 28.77a6.317 6.317 0 0 1-6.316 6.316H33l-.016 6.977L26 35.085H11.156c-3.5 0-6.316-2.824-6.316-6.5V15.19c0-3.293 2.824-6.12 6.316-6.12m10.125 8.918v8.149'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M22.602 23.855h-5.606l4.285-5.867m-10.664 1.528C11.25 18.5 13.652 17.5 14.691 19c2.04 2.977-3.89 2.957-3.89 7.137h4.418m17.203-8.187h4.96s-3.405 4.726-3.405 8.226'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='m25.902 26.473 2.836-8.82' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNeedHelp
